import type { ComponentType } from 'react';
import { SEOHead } from '@/components/layout/SEOHead';
import { FadeIn } from '@/components/motion/FadeIn';

interface LegalPageProps {
  title: string;
  description: string;
  canonical: string;
  Body: ComponentType;
  headline: string;
}

export function LegalPage({ title, description, canonical, Body, headline }: LegalPageProps) {
  return (
    <>
      <SEOHead title={title} description={description} canonical={canonical} ogImage="/posters/og-default.jpg" />
      <section className="page-hero">
        <div className="container">
          <FadeIn>
            <p className="eyebrow">Brian Ellison Design</p>
            <h1 className="page-hero__title">{headline}</h1>
          </FadeIn>
        </div>
      </section>
      <section className="container section legal-body">
        <FadeIn>
          <Body />
        </FadeIn>
      </section>
    </>
  );
}
